import React from "react";
import Button from "../../../../../server/public/shared/ui/inputs/classicButton.js";
import DeleteButton from "../deleteButton/deleteButton.js";
import Provider from "./Provider.js";
export default function SumProvider(props) {
    var _a;
    const { provider } = props;
    return (React.createElement("div", { className: "" }, (_a = provider.values) === null || _a === void 0 ? void 0 :
        _a.map((p, index) => (React.createElement("div", { className: "sum-provider-item" },
            React.createElement("b", null, "+"),
            React.createElement(Provider, { provider: p, hasHiddenType: props.hasHiddenType, onProviderUpdate: (newP) => props.onProviderUpdate({
                    ...provider,
                    values: provider.values.map((p, i) => index !== i ? p : newP),
                }), key: index, formatNames: props.formatNames }),
            React.createElement(DeleteButton, { onClick: () => props.onProviderUpdate({
                    ...provider,
                    values: provider.values.filter((_, i) => i !== index),
                }) })))),
        React.createElement("br", null),
        React.createElement(Button, { text: "Dodaj nowy element", value: "add-new-element", onClick: () => {
                var _a;
                return props.onProviderUpdate({
                    ...provider,
                    values: [
                        ...((_a = provider.values) !== null && _a !== void 0 ? _a : []),
                        { type: "constant", value: 0 },
                    ],
                });
            } })));
}
